import { AnyAction } from 'redux';
import { actionTypes } from '../common/constants/actionTypes';

import CertificateContentPage from '../api/certificatesContentPageEntity';
import CompetencesContentPage from '../api/competencesPageEntity';
import ContentPage from '../api/contentPageEntity';
import VttError from '../api/vttError';

export interface IMainContentState {
  certificatesPageItem: CertificateContentPage;
  competencesPageItem:  CompetencesContentPage;
  cookieBannerVisible:  boolean;
  currentContentPage:   ContentPage;
  errorDescription:     VttError;
}

const initialState: IMainContentState = {
  certificatesPageItem: new CertificateContentPage(),
  competencesPageItem:  new CompetencesContentPage(),
  cookieBannerVisible:  false,
  currentContentPage:   new ContentPage(),
  errorDescription:     new VttError(),
};

export const mainContentReducer = (
  state: IMainContentState = initialState,
  action: AnyAction
): IMainContentState => {
  switch (action.type) {
    case actionTypes.FETCH_CERTIFICATES_ITEMS_COMPLETED:
      return {
        ...state,
        certificatesPageItem: action.payload,
        errorDescription: new VttError(),
      };

    case actionTypes.FETCH_COMPETENCES_ITEMS_COMPLETED:
      return {
        ...state,
        competencesPageItem: action.payload,
        errorDescription: new VttError(),
      };

    case actionTypes.FETCH_CONTENT_PAGE_BY_ID_COMPLETED:
      return {
        ...state,
        currentContentPage: action.payload,
        errorDescription: new VttError(),
      };

    case actionTypes.SET_COOKIE_BANNER_VISIBILITY:
      return {
        ...state,
        cookieBannerVisible: action.payload,
      };

    case actionTypes.FETCH_CONTENT_PAGE_ERROR:
      return {
        ...state,
        errorDescription: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mainContent.ts